<h2 class="dialog-title" mat-dialog-title>{{ 'EMAILS.TEMPLATES.TITLE' | translate }}</h2>
<p class="dialog-subtitle">{{ 'EMAILS.TEMPLATES.CAPTION' | translate }}</p>
<div class="select-template-content">
  <glxy-table-container
    [dataSource]="dataSource"
    [columns]="(columns$ | async) ?? []"
    [showSelection]="false"
    [showFooter]="true"
    [fullWidth]="true"
    [displayOption]="displayOption()"
    [pageSize]="25"
  >
    <glxy-table-content-header
      [showColumnArrange]="false"
      [showFilters]="true"
      [showFiltersOpen]="false"
      [showSearch]="true"
      [showSort]="false"
      [showExport]="false"
      [showActions]="false"
      [showDisplayToggle]="false"
      [display]="displayOption()"
      (displayChanges)="displayOption.set($event)"
    >
      <glxy-filter-chips (filtersChanged)="handleFiltersChanged($event)" filters-area></glxy-filter-chips>
    </glxy-table-content-header>

    <div glxy-grid-content class="cards-wrapper">
      @if ((isMobile$ | async) === false) {
        <email-blank-card (readOnlyEmailClicked)="blankTemplateSelected()"></email-blank-card>
        <email-card
          *glxyGridCard="let row"
          [email]="row.template"
          [defaultAction]="DefaultCardAction.USE"
          [readOnly]="true"
          (readOnlyEmailClicked)="templateSelected(row)"
        ></email-card>
      } @else {
        <div (click)="blankTemplateSelected()">
          <div class="template-title">{{ 'EMAILS_TEMPLATES.BLANK' | translate }}</div>
        </div>
        <div *glxyGridCard="let row" (click)="templateSelected(row)">
          <div class="template-title">{{ row.template.title }}</div>
          <div>
            @if (row.template.updated <= row.template.created) {
              {{ 'EMAIL_LIBRARY.CARD.CREATED' | translate }}
            }
            @if (row.template.updated > row.template.created) {
              {{ 'EMAIL_LIBRARY.CARD.UPDATED' | translate }}
            }
            {{ formatDate(row.template.updated, currentLocale$ | async) }}
          </div>
        </div>
      }
    </div>
  </glxy-table-container>
</div>
<mat-dialog-actions align="end">
  <button mat-stroked-button mat-dialog-close>{{ 'COMMON.ACTION_LABELS.CANCEL' | translate }}</button>
</mat-dialog-actions>
